import { useHomeCardsContext } from './HomeCardsContext';
import { isBookableCoachCard, MeetCoachCardGate } from './homeCardGates';

/**
 * Full-width coach booking cards ("Schedule a chemistry call", biweekly).
 *
 * Rendered directly under the greeting, above the Moments block and the "For
 * you" carousel: per design, a member is unlikely to see this and the Moments
 * section at once, since Moments only appears after the first recurring session.
 * It renders nothing while cards are loading — there is no skeleton for it, and
 * a placeholder above the fold would shift the whole page on settle.
 */
const CoachBookingCards = () => {
  const {
    appointments,
    appointmentState,
    cards,
    isLoading,
    now,
    matchStateForCoach,
    onDismiss,
    refetch,
  } = useHomeCardsContext();

  if (isLoading) {
    return null;
  }

  const bookableCoachCards = cards.filter(isBookableCoachCard);
  if (bookableCoachCards.length === 0) {
    return null;
  }

  return (
    <div className="mb-6 flex max-w-screen-lg flex-col gap-4 px-4 md:px-0">
      {bookableCoachCards.map((card) => (
        <MeetCoachCardGate
          key={`chem-${card.id}`}
          appointments={appointments}
          appointmentState={appointmentState}
          card={card}
          matchState={matchStateForCoach(card.coach?.id ?? '')}
          now={now}
          variant="chemistry"
          {...card}
          refetch={refetch}
          onDismiss={onDismiss}
        />
      ))}
      {bookableCoachCards.map((card) => (
        <MeetCoachCardGate
          key={`biweekly-${card.id}`}
          appointments={appointments}
          appointmentState={appointmentState}
          card={card}
          matchState={matchStateForCoach(card.coach?.id ?? '')}
          now={now}
          variant="biweekly"
          {...card}
          refetch={refetch}
          onDismiss={onDismiss}
        />
      ))}
    </div>
  );
};

export default CoachBookingCards;
